import React from "react";

const Loader_10 = ({text}) => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="spinner-border" role="status"
        style={{fontSize: '7px', width: '25px', height: '25px'}}>
      </div>
      <span className="px-1"></span>
      <span>{text}</span>
    </div>
  );
};

export default Loader_10;